import React, { ReactNode } from 'react';
import './panel-heading.scss';

interface PanelHeadingProps {
  title: ReactNode;
  /** Small right-aligned figure or note: a count, a date. */
  meta?: ReactNode;
  /** Right-aligned control. Give a button `className="panel-heading__action"` for the tiny pill. */
  action?: ReactNode;
  /** One sentence under the heading saying what the section is for. */
  hint?: ReactNode;
  /** Top margin separating it from what is above: a section (`true`) or a subsection (`'sm'`). */
  spaced?: boolean | 'sm';
  as?: 'h3' | 'h4' | 'h5';
  /** Anchor for a jump link (the PEP summary scrolls to it). */
  id?: string;
  className?: string;
}

/**
 * The uppercase micro-heading the document editor's panels use, with its
 * optional meta, action and hint line. A section is this plus whatever
 * follows it; there is no wrapper element, so grids and tables sit directly
 * under the heading.
 */
const PanelHeading: React.FC<PanelHeadingProps> = ({
  title,
  meta,
  action,
  hint,
  spaced = false,
  as: Tag = 'h4',
  id,
  className = '',
}) => (
  <>
    <div id={id} className={`panel-heading ${spaced === 'sm' ? 'panel-heading--spaced-sm' : spaced ? 'panel-heading--spaced' : ''} ${className}`.trim()}>
      <Tag className="panel-heading__title">{title}</Tag>
      {(meta !== undefined || action) && (
        <div className="panel-heading__right">
          {meta !== undefined && <span className="panel-heading__meta">{meta}</span>}
          {action}
        </div>
      )}
    </div>
    {hint && <p className="panel-hint">{hint}</p>}
  </>
);

export default PanelHeading;
